import React, { useState } from 'react'
import { AutoComplete } from 'primereact/autocomplete'
import eccss from "../../../styles/ExternalCalls.module.css"
import { Button } from 'primereact/button'
import { formatPhoneNumberInput, validatePhoneNumber } from '../Utils'

const PhoneAutocomplete = ({ suggestions, value, setValue, loading, icon, iconAction }) => {
    const [filteredSuggestions, setFilteredSuggestions] = useState([])

    const searchSuggestions = (event) => {
        const query = event.query.replace(/\D/g, '') // Just digits
        const filtered = suggestions.filter((item) =>
            item.replace(/\D/g, '').startsWith(query)
        )
        setFilteredSuggestions(filtered)
    }

    const handleInputChange = (e) => {
        const inputValue = e.target.value
        const numericValue = inputValue.replace(/\D/g, '') // Just digits

        if (numericValue.length <= 10) {
            const formattedValue = formatPhoneNumberInput(numericValue)
            setValue(formattedValue)
        }
    }

    const onSelectSuggestion = (e) => {
        setValue(formatPhoneNumberInput(e.value))
    }

    const itemTemplate = (item) => {
        return (
            <div>{formatPhoneNumberInput(item)}</div>
        )
    }

    const onBlurHandler = () => {
        if (!validatePhoneNumber(value)) {
            setValue('')
        }
    }

    const onKeyPressHandler = (e) => {
        const numericValue = value?.replace(/\D/g, '')

        if (!/^\d$/.test(e.key) || numericValue?.length >= 10) {
            e.preventDefault()
        }
    }

    return (
        <div className={eccss.autocomplete_container}>
            <AutoComplete
                value={value}
                suggestions={filteredSuggestions}
                completeMethod={searchSuggestions}
                onChange={handleInputChange}
                onSelect={onSelectSuggestion}
                itemTemplate={itemTemplate}
                onKeyPress={onKeyPressHandler}
                placeholder="(999) 999-9999"
                onBlur={onBlurHandler}
                style={{ width: '100%' }}
                disabled={loading}
                inputStyle={{ width: '100%', paddingRight: '30px' }}
            />
            {loading && <i className={`${eccss.loading_icon} pi pi-spin pi-spinner`}></i>}
            {!loading && icon &&
                <Button
                    icon={<img src={icon} style={{ height: "15px" }} />}
                    disabled={loading || !validatePhoneNumber(value)}
                    onClick={() => {
                        if (validatePhoneNumber(value))
                            iconAction(value)
                    }}
                    style={{
                        background: "transparent",
                        border: "none",
                        padding: "0",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        position: "absolute",
                        top: "18%",
                        right: "0"
                    }}
                />
            }
        </div>
    )
}

export default PhoneAutocomplete